import { createSelector } from '@app/utils/createSelector'

import type { Result } from '@app/packages/Result/Result'

import { createDepersonalizedAnnouncementBundleSelector } from '@app/store/slices/bundles'
import { depersonalizedAnnouncementsIdListSelector, depersonalizedAnnouncementsMetaSelector } from '@app/store/slices/depersonalized_announcements'
import { profileUserSelector } from '@app/store/slices/profile'

export const shouldUseDepersonalizedAnnouncementsSelector = createSelector([profileUserSelector], user => {
  if (user?.account_type === 'sitter' && user.approved) return false
  return true
})

export const depersonalizedAnnouncementsCompleteSelector = createSelector([depersonalizedAnnouncementsMetaSelector], meta => !!meta.fetched)

export const depersonalizedAnnouncementsListSelector = createSelector(
  [(state: unknown) => state],
  state => {
    const ids = depersonalizedAnnouncementsIdListSelector(state)
    const models = ids.map(id => createDepersonalizedAnnouncementBundleSelector(id)(state))
    return models
  },
  {
    resultEqual(a, b) {
      if (a.length !== b.length) return false
      for (let i = 0; i < a.length; i++) {
        if (!resultEqual(a[i], b[i])) return false
      }
      return true
    },
  }
)

const resultEqual = <T>(a: Result<T>, b: Result<T>) => {
  if (a.error && b.error) return errorEqual(a.value, b.value)
  if (!a.error && !b.error) return a.value === b.value
  return false
}

const errorEqual = (a: unknown, b: unknown) => {
  if (a instanceof Error && b instanceof Error) return a.message === b.message
  return false
}
